<template>
  <el-col :span="24">
    <div
      class="ma-0"
      v-loading="loading"
      :element-loading-spinner="svg"
      element-loading-svg-view-box="-10, -10, 50, 50"
      element-loading-background="rgba(122, 122, 122, 0.8)"
    >
    <div
      v-if="$store.state.auth.user != null"
      class="d-flex justify-content-start mb-2"
    >
      <el-button
        v-if="selectedRows.length > 0"
        class="custom-filter-button-apply"
        size="large"
        :disabled="selectedRows.length <= 0"
        @click="bulkDownloadSelectedRows"
      >
        <span class="moderat-btn-apply"> Download </span>
      </el-button>
      <el-button
        v-if="
          selectedRows.length > 0 &&
          !$store.state.auth.user.is_auditor
        "
        type="danger"
        size="large"
        :disabled="selectedRows.length <= 0"
        @click="bulkDeleteSelectedRows"
      >
      <span class="moderat-btn-apply"> Delete </span>
      </el-button>
      
    </div>

    <div class="custom-table-design">
      <el-table
        :data="userDataList"
        :fit="true"
        :height="tableHeightProp"
        stripe
        :row-class-name="tableRowClassName"
        @row-click="handleRowClick"
        @selection-change="handleSelectionChange"
        class="my-2 data-table"
        scrollbar-always-on: false
      >
        <el-table-column
          v-if="$store.state.auth.user != null"
          type="selection"
          width="55"
        />
        <el-table-column label="File" :width="$vuetify.display.width <= 1400 ? 250 : ''" sortable>
          <template #default="scope">
            {{ formatFileName(scope.row.file) }}
          </template>
        </el-table-column>

        <el-table-column
          label="Category"
          :width="$vuetify.display.width <= 1400 ? 180 : ''"
          sortable
        >
          <template #default="scope">
            {{ formatCategory(scope.row.category) }}
          </template>
        </el-table-column>

        <el-table-column
          label="Size"
          :width="$vuetify.display.width <= 1400 ? 100 : ''"
          sortable
        >
          <template #default="scope">
            {{ formatFileSize(scope.row.file) }}
          </template>
        </el-table-column>

        <el-table-column v-if="$store.state.auth.user != null && $store.state.auth.user.is_admin"
          label="Customer"
          :prop="'customer'"
          :width="$vuetify.display.width <= 1400 ? 200 : ''"
          sortable
        />

        <el-table-column
          label="Uploaded by"
          :prop="'user'"
          :width="$vuetify.display.width <= 1400 ? 200 : ''"
          sortable
        />

        <el-table-column
          label="Created at"
          :prop="'created_at'"
          :width="$vuetify.display.width <= 1400 ? 200 : ''"
          sortable
        >
          <template #default="scope">
            <i class="fa fa-calendar f-14 me-primary mr-2"></i>
            {{ scope.row.created_at == null ? "" : scope.row.created_at.split("T")[0] }}
          </template>
        </el-table-column>

        <el-table-column
          v-if="$store.state.auth.user != null && $store.state.auth.user.is_admin && !$store.state.auth.user.is_auditor"
          label="Deleted"
          :prop="'is_deleted'"
          align="center"
          :width="$vuetify.display.width <= 1400 ? 120 : ''"
          sortable
        >
          <template #default="scope">
            <el-tag
              v-if="scope.row.is_deleted != null"
              :type="scope.row.is_deleted ? 'danger' : 'success'"
              effect="dark"
              round
              class="deleted-status-tag"
            >
              {{ scope.row.is_deleted ? "Yes" : "No" }}
            </el-tag>
          </template>
        </el-table-column>

        <el-table-column
          fixed="right"
          :label="'Actions'"
          :prop="'operations'"
          align="center"
          width="150"
        >
          <template #default="scope">
            <el-tooltip placement="top" effect="light">
              <template #content>Download</template>
              <el-button
                v-if="scope.row.file && scope.row.file.url"
                class="height-25 rounded-2 m-0 ml-2"
                @click.stop="downloadFile(scope.row)"
                size="small"
                color="#DDF0AC"
                style="width: 25px; height: 25px; padding: 0px; align-items: center;"
              >
                <svg style="width: 24px; height: 24px;">
                  <use href="@/assets/svg/newSvgIcon.svg#tableOperationDownload"></use>
                </svg>
              </el-button>
            </el-tooltip>
            <el-tooltip placement="top" effect="light">
              <template #content>Delete</template>
              <el-button
                v-if="
                  scope.row.id != null &&
                  scope.row.id != '' &&
                  $store.state.auth.user != null &&
                  !$store.state.auth.user.is_auditor
                "
                class="height-25 rounded-2 m-0 ml-2"
                @click.stop="deleteRow(scope.row, scope.$index)"
                size="small"
                color="#DDF0AC"
                style="width: 25px; height: 25px; padding: 0px; align-items: center;"
                :disabled="scope.row.is_deleted"
              >
                <svg style="width: 24px; height: 24px;">
                  <use href="@/assets/svg/newSvgIcon.svg#tableOperationDelete"></use>
                </svg>
              </el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="custom-pagination" v-if="$vuetify.display.width >= 700">
      <el-row class="row-bg" justify="space-between">
        <el-col
          :span="5"
          class="d-flex justify-content-start align-items-center"
        >
          <el-select
            v-model="perPageCount"
            placeholder="Select"
            size="small"
            style="width: 70px"
          >
                        <el-option label="10" :value="'10'" />
                        <el-option label="25" :value="'25'" />
                        <el-option label="50" :value="'50'" />
                        <el-option label="100" :value="'100'" />
                        <el-option label="500" :value="'500'" />
                        <el-option label="1k" :value="'1000'" />
          </el-select>
        </el-col>

        <el-col
          :span="8"
          class="d-flex align-items-center justify-content-center"
        >
          <el-pagination
            small
            background
            layout="prev, pager, next"
            :total="total_items"
            v-model:page-size="page_size"
            v-model:current-page="current_page"
            @current-change="changePage"
            class="my-4"
          />
        </el-col>
        <el-col :span="5" class="d-flex justify-content-end align-items-center">
          <span class="text-white">
            {{ ((current_page - 1) * perPageCount + 1).toLocaleString() }}-{{
              current_page * perPageCount > total_items
                ? total_items.toLocaleString()
                : (current_page * perPageCount).toLocaleString()
            }}
            of {{ total_items.toLocaleString() }}
          </span>
        </el-col>
      </el-row>
    </div>
    <div class="custom-pagination" v-if="$vuetify.display.width < 700">
      <el-row class="row-bg" justify="space-between">
        <el-col
          :span="24"
          class="d-flex align-items-center justify-content-center"
        >
          <el-pagination
            small
            background
            layout="prev, pager, next"
            :total="total_items"
            v-model:page-size="page_size"
            v-model:current-page="current_page"
            @current-change="changePage"
            class="my-4"
          />
        </el-col>
        <el-col
          :span="10"
          class="d-flex justify-content-end align-items-center"
        >
          <el-select
            v-model="perPageCount"
            placeholder="Select"
            size="small"
            style="width: 70px"
          >
                        <el-option label="10" :value="'10'" />
                        <el-option label="25" :value="'25'" />
                        <el-option label="50" :value="'50'" />
                        <el-option label="100" :value="'100'" />
                        <el-option label="500" :value="'500'" />
                        <el-option label="1k" :value="'1000'" />
          </el-select>
        </el-col>
        <el-col :span="10" class="d-flex justify-content-start align-items-center">
          <span class="text-white">
            {{ ((current_page - 1) * perPageCount + 1).toLocaleString() }}-{{
              current_page * perPageCount > total_items
                ? total_items.toLocaleString()
                : (current_page * perPageCount).toLocaleString()
            }}
            of {{ total_items.toLocaleString() }}
          </span>
        </el-col>
      </el-row>
    </div>

    </div>
  </el-col>
</template>

<script>
// import { ElMessageBox } from "element-plus";
// import ShowDetail from "./dialogDetail.vue";
import UserService from "../../services/user.service";
export default {
  props: {
    loadingProp: {
      type: Boolean,
      default: false,
    },
    usersDataProp: {
      type: Array,
      default(rawProps) {
        return rawProps;
      },
    },
    totalRowProp: {
      type: Number,
    },
    tableHeightProp: {
      type: Number,
      default: 400,
    },
  },
  components: {
    // ShowDetail,
  },
  data() {
    return {
      show: true,
      userDataList: [],
      search: "",
      current_page: 1,
      page_size: 50,
      total_items: 100,
      perPageCount: 50,
      loading: false,
      show_modal: false,
      data_modal: null,
      current_row_index: null,
      filterOpen: false,
      selectedRows: [],
    };
  },
  watch: {
    loadingProp: {
      handler: function (newValue) {
        this.loading = newValue;
      },
      deep: true,
    },
    usersDataProp: {
      handler: function (newValue) {
        this.userDataList = newValue;
      },
      deep: true,
    },
    totalRowProp: {
      handler: function (newValue) {
        this.total_items = newValue;
        console.log(this.total_items);
      },
      deep: true,
    },
    perPageCount: function (newVal) {
      this.current_page = 1;
      this.page_size = parseInt(newVal);
      this.$emit("tableAction", {
        index: this.page_size,
        data: null,
        kind: "perPageChange",
      });
    },
  },
  methods: {
    formatFileName(file) {
      if (!file || !file.name) {
        return "";
      }
      return file.name.split("/").pop();
    },
    triggerFileDownload(file) {
      if (!file || !file.url) {
        return false;
      }
      try {
        const link = document.createElement("a");
        link.href = file.url;
        link.download = this.formatFileName(file);
        link.target = "_blank";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        return true;
      } catch (error) {
        console.warn("Failed to trigger bucket file download.", error);
        return false;
      }
    },
    downloadFile(row) {
      if (!row || !this.triggerFileDownload(row.file)) {
        return;
      }
      this.logAuditorDownloadHistory([row]);
    },
    logAuditorDownloadHistory(rows) {
      const user = this.$store.state.auth.user;
      if (!user || !user.is_auditor || rows.length == 0) {
        return;
      }

      const body = {
        files: rows.map((file) => ({
          file_id: file.id,
          file_name: file.file?.name || file.name,
          category: file.category,
          file_created_at: file.created_at,
        })),
      };

      UserService.logBucketFileAction(body).catch((error) => {
        console.warn("Failed to save auditor download history.", error);
      });
    },
    formatCategory(category) {
      const labels = {
        sessions: "Sessions",
        "unallocated-sessions": "Unallocated sessions",
        "sessions-with-abatement": "Sessions with abatement",
        "charger-logs": "Charger logs",
        auditor: "Auditor",
        other: "Other",
      };
      return labels[category] || category || "";
    },
    formatFileSize(file) {
      if (!file || file.size_mb == null) {
        return "";
      }
      return `${Number(file.size_mb).toLocaleString()} MB`;
    },
    handleRowClick(row, column, event) {
      console.log(row, column, event);
    },
    handleSelectionChange(rows) {
      this.selectedRows = rows;
    },
    bulkDeleteSelectedRows() {
      this.$emit("tableAction", {
        index: null,
        data: this.selectedRows,
        kind: "bulkDelete",
      });
    },
    bulkDownloadSelectedRows() {
      const downloadedRows = this.selectedRows.filter((row) =>
        this.triggerFileDownload(row.file)
      );

      this.logAuditorDownloadHistory(downloadedRows);
    },
    handleShow(index, data) {
      this.$emit("tableAction", { index: index, data: data, kind: "edit" });
    },
    deleteRow(event, index) {
      this.$emit("tableAction", { index: index, data: event, kind: "delete" });
    },
    changePage(page) {
      this.$emit("tableAction", {
        index: page,
        data: null,
        kind: "changePage",
      });
    },
  },
};
</script>

